<template>
  <div class="about" data-aos="fade-up">
    
            <div class="section-title">
              <h2>About Me</h2>
              <p>My passion for the tech industry started when I chose IT as a subject in high school</p>
            </div>
    
            <div class="row">
              <div class="col-lg-4">
                <img src="@/assets/pics/home.jpg" class="img-fluid" alt="">
              </div>
              <div class="col-lg-8 pt-4 pt-lg-0 content">
                <h3>Front-End Developer &amp; Musician.</h3>
                <p class="fst-italic">
                 I see a lot of potential in myself as a developer/proggrammer and know that the sky is the only limit!
                </p>
                <div class="row">
                  <div class="col-lg-6">
                    <ul>
                      <li><i class="bi bi-chevron-right"></i> <strong>Birthday:</strong> <span>15 July 2002</span></li>
                      <li><i class="bi bi-chevron-right"></i> <strong>Website:</strong> <span>www.example.com</span></li>
                      <li><i class="bi bi-chevron-right"></i> <strong>Phone:</strong> <span>0814937507</span></li>
                      <li><i class="bi bi-chevron-right"></i> <strong>City:</strong> <span>Cape Town, SA</span></li>
                    </ul>
                  </div>
                  <div class="col-lg-6">
                    <ul>
                      <li><i class="bi bi-chevron-right"></i> <strong>Age:</strong> <span>19</span></li>
                      <li><i class="bi bi-chevron-right"></i> <strong>Highest Qualification:</strong> <span>Matric</span></li>
                      <li><i class="bi bi-chevron-right"></i> <strong>E-Mail:</strong> <span>akhakombora07@gmail.com</span></li>
                      <li><i class="bi bi-chevron-right"></i> <strong>Freelance:</strong> <span>Available</span></li>
                    </ul>
                  </div>
                </div>
                <p>
                    I am a quick learner and have a methodical customer-focused approach to work and a strong drive to
                    improve everything around me and all that I touch. I strive to gain the necessary experience to
                    become one of the most dependable and hardest working individuals, through the value and service I
                    shall bring to the company I get employed by.  </p>
              </div>
            </div>
    
          </div>
</template>
<script>
export default {
  
}
</script>
<style scoped>
#about{
overflow-x: hidden;
}
.about .content h3 {
  font-weight: 700;
  font-size: 26px;
  color: #728394;
}
.about .content ul {
  list-style: none;
  padding: 0;
}
.about .content ul li {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.about .content ul i {
  font-size: 16px;
  margin-right: 5px;
  color: #e7eef5;
  line-height: 0;
}
.about .content p:last-child {
  margin-bottom: 0;
}
.about{background-color:#d3e3f3;}
</style>